import isEmpty from 'lodash/isEmpty';
import pickBy from 'lodash/pickBy';
import { useRouter } from 'next/router';
import { useCallback } from 'react';

import { makeFiltersQueryObject } from '@src/helpers/filters';
import { isServer } from '@src/utils';
import { easyQueryReplace } from '@src/utils/routing';
import { mergeQueryReplace } from '@src/utils/url/mergeQuery';

import { useDebounceCallback } from './useDebounceCallback';

interface IParams<T> {
  newQuery: Partial<T>;
  defaultQuery: Partial<T>;
}

export const useQueryReplace = <T extends {}>() => {
  const router = useRouter();

  return useDebounceCallback(({ newQuery, defaultQuery }: IParams<T>) => {
    const queryParams = makeFiltersQueryObject({
      filters: newQuery,
      defaultFilters: defaultQuery,
    });

    return easyQueryReplace(router, queryParams);
  }, 600);
};

export function useQueryReplacerSimple() {
  const router = useRouter();

  const updateQuery = useCallback(
    (newQuery: Record<string, any>) => {
      if (!router.isReady || isServer) return;
      mergeQueryReplace(router, newQuery, { shallow: true, scroll: false });
    },
    [router],
  );

  return updateQuery;
}
